import React, { useState, useRef, useEffect } from 'react'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import { motion, AnimatePresence } from "framer-motion"
import PropTypes from 'prop-types'
import { Portal } from 'react-portal'

const ModalComponent = ({ children, className, trigger }) => {

  const [modalState, setModalState] = useState(false)

  const animateModal = {
    show: {
      opacity: 1,
      y: 0,
    },
    hide: { 
      opacity: 0,
      y: -300,
    },
  }

  const ref = useRef();

  useOnClickOutside(ref, () => {
    setModalState(false);
  });

  function useOnClickOutside(ref, handler) {
    useEffect(
      () => {
        const listener = event => {
          if (!ref.current || ref.current.contains(event.target)) {
            return;
          }
  
          handler(event);
        };
  
        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);
  
        return () => {
          document.removeEventListener('mousedown', listener);
          document.removeEventListener('touchstart', listener);
        };
      },
      [ref, handler]
    );
  }

  const handleModal = () => {
    setModalState(!modalState);
  }

  const closeModal = () => {
    setModalState(false);
  }

  return (
    <>
      <Portal>
        <AnimatePresence>
          {modalState && (
            <div className={className}>
              <motion.div
                className="overlay"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                onClick={closeModal}
              >
              </motion.div>
              <motion.div
                className="modal-content"
                initial="hide"
                animate="show"
                exit="hide"
                variants={animateModal}
              >
                <span ref={ref}>
                  {children}
                </span>
              </motion.div>
            </div>
          )}
        </AnimatePresence>
      </Portal>
      <span onClick={handleModal}>
        {trigger}
      </span>
    </>
  )
}

ModalComponent.propTypes = {
  className: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  trigger: PropTypes.object
}
  
const Modal = styled(ModalComponent)`
  ${tw``}
  .modal-content {
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 31;
    top: 0;
    left: 0%;
    right: 0;
    bottom: 0;
  }
  .overlay {
    background-color: rgba(0,0,0,0.6);
    position: fixed;
    z-index: 30;
    top: 0;
    left: 0%;
    right: 0;
    bottom: 0;
  }
  
`

export default Modal